export enum ExtendedAttributeType {
    Number = 1,
    Text = 2,
    Date = 3,
    Address = 4,
}
